module.exports = __webpack_public_path__ + "img/image-8.59e39595.png";